import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/header-3.jpg";
import Card1 from "../Images/CIRCODU-BANNERS-4.jpg";
import "../Pages/OurHistory.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function WasteManagement() {
  return (
    <div className="ne-page">
      <SEO
        title="Waste Management"
        description="Waste is more than an inconvenience; unmanaged, it is a direct threat to public health, biodiversity, and the communities we call home. CIRCODU recognizes that responsible waste management is not optional; it is essential. And we are committed to driving the cultural, behavioral, and systemic shifts needed to make Uganda cleaner, healthier, and more sustainable."
        keywords="waste management, waste reduction, resource recovery, safe disposal, public health, environment, CIRCODU, Sustainable Development Goal 12, waste management Uganda, waste reduction Uganda, resource recovery Uganda, safe disposal Uganda, waste management practices Uganda, waste management education Uganda, waste management policies Uganda, waste-to-energy solutions Uganda, community waste management Uganda"
        url="/our-thematic-areas/waste-management"
        image={Card1}
        type="website"
      />

      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Waste Management</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Our Thematic Areas
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Waste Management
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="section border-bottom">
        <div className="container border-top">
          <div className="row">
            <div className="col-md-12 mt-2">
              {/* Intro */}
              <h5 style={{ color: "#008250", fontSize: "16px" }}>
                <b>Waste Management</b>
              </h5>
              <p className="texty">
                Waste is more than an inconvenience; unmanaged, it is a direct
                threat to public health, biodiversity, and the communities we
                call home. CIRCODU recognizes that responsible waste management
                is not optional; it is essential. And we are committed to
                driving the cultural, behavioral, and systemic shifts needed to
                make Uganda cleaner, healthier, and more sustainable.
              </p>
              <p className="texty">
                Through this work, CIRCODU contributes to the achievement of{" "}
                <b>Sustainable Development Goal 12,</b> ensuring sustainable
                consumption and production patterns for people and planet alike.
              </p>

              {/* Our Overall Objective */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🎯 Our Overall Objective</b>
              </h5>
              <p className="texty">
                To promote responsible and sustainable waste management
                practices across Uganda by{" "}
                <b>
                  reducing waste generation, encouraging resource recovery, and
                  ensuring safe disposal,
                </b>{" "}
                safeguarding public health and the environment for current and
                future generations.
              </p>

              {/* Specific Objectives */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🔑 Specific Objectives</b>
              </h5>
              <ol className="texty mt-2">
                <li className="mt-2">
                  <b>Promote Waste Reduction and Resource Efficiency:</b> We
                  encourage communities, institutions, and enterprises to
                  embrace the principles of <b>reduce, reuse, and recycle,</b>{" "}
                  shifting mindsets from a throwaway culture to one that sees
                  waste as a resource waiting to be recovered.
                </li>
                <li className="mt-2">
                  <b>Strengthen Waste Segregation and Collection Systems:</b>{" "}
                  Effective waste management starts at the source. We support
                  the development and implementation of{" "}
                  <b>
                    waste segregation, collection, and transportation systems
                  </b>{" "}
                  that ensure waste is handled safely and efficiently from
                  household to disposal, reducing contamination and protecting
                  communities along the way.
                </li>
                <li className="mt-2">
                  <b>Promote Safe Disposal and Hazardous Waste Management:</b>{" "}
                  Not all waste is equal, and not all waste can simply be
                  discarded. CIRCODU advocates for and supports{" "}
                  <b>environmentally sound disposal methods,</b> including
                  responsible landfill management and the safe handling of
                  hazardous waste to prevent pollution, protect ecosystems, and
                  preserve public health.
                </li>
                <li className="mt-2">
                  <b>Build Capacity and Raise Awareness:</b> Lasting change
                  requires informed people. We equip communities, local
                  governments, and key stakeholders with the{" "}
                  <b>knowledge, skills, and tools</b> to manage waste
                  responsibly and champion sustainable consumption and
                  production patterns in their own spheres of influence.
                </li>
              </ol>
            </div>
            <div className="col-md-8">
              {/* Our Actions on the Ground */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>⚙️ Our Actions on the Ground</b>
              </h5>
              <ol className="texty mt-2">
                <li className="mt-2">
                  🗑️ <b>Community Waste Awareness Campaigns:</b> We design and
                  deliver targeted education and outreach programs that inspire
                  real behavior change around waste reduction, segregation, and
                  responsible disposal, reaching households and communities
                  where habits are formed, and futures are shaped.
                </li>
                <li className="mt-2">
                  ♻️ <b>Supporting Recycling and Upcycling Initiatives:</b>{" "}
                  CIRCODU partners with local enterprises and community groups
                  to establish recycling programs that{" "}
                  <b>convert waste materials into useful products,</b> fostering
                  local entrepreneurship, reducing landfill burden, and building
                  a circular economy from the ground up.
                </li>
                <li className="mt-2">
                  📋 <b>Advocating for Waste Management Policies:</b> Change at
                  the community level must be matched by change at the policy
                  level. We actively engage with policymakers and regulatory
                  bodies to promote the{" "}
                  <b>
                    development and enforcement of waste management regulations
                  </b>{" "}
                  that align with national and international environmental
                  standards, ensuring accountability across the board.
                </li>
                <li className="mt-2">
                  ⚡ <b>Piloting Waste-to-Energy Solutions:</b> Why dispose of
                  waste when you can transform it? CIRCODU explores and
                  implements <b>waste-to-energy technologies,</b> including
                  biogas production from organic waste that simultaneously
                  tackle waste management challenges and expand access to clean
                  energy. One problem, one solution, two victories.
                </li>
              </ol>
            </div>
            <div
              className="col-md-4 mb-1"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="imagecard" style={{ width: "100%" }}>
                <img
                  src={Card1}
                  alt="CIRCODU Waste Management Programs"
                  width="100%"
                  style={{ borderRadius: "5%", objectFit: "cover" }}
                />
              </div>
            </div>

            <hr />
            <div className="col-md-12">
              {/* Closing statement */}
              <p className="texty">
                <i>
                  Waste is only waste when we treat it that way. At CIRCODU, we
                  see potential where others see pollution, and we are turning
                  that potential into progress.
                </i>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WasteManagement;
